export default [
  {
    type: "monthly",
    year: 2021,
    month: 1,
    btc: 199,
    source: "https://bitfarms.com/app/uploads/2021/09/Bitfarms-Press-Release-Aug-BTC-Production-Update-FINAL-v9-Sep-8-2021.pdf"
  },
  {
    type: "monthly",
    year: 2021,
    month: 2,
    btc: 178,
    source: "https://bitfarms.com/app/uploads/2021/09/Bitfarms-Press-Release-Aug-BTC-Production-Update-FINAL-v9-Sep-8-2021.pdf"
  },
  {
    type: "monthly",
    year: 2021,
    month: 3,
    btc: 221,
    source: "https://bitfarms.com/app/uploads/2021/09/Bitfarms-Press-Release-Aug-BTC-Production-Update-FINAL-v9-Sep-8-2021.pdf"
  },
  {
    type: "monthly",
    year: 2021,
    month: 4,
    btc: 232,
    source: "https://bitfarms.com/app/uploads/2021/09/Bitfarms-Press-Release-Aug-BTC-Production-Update-FINAL-v9-Sep-8-2021.pdf"
  },
  {
    type: "monthly",
    year: 2021,
    month: 5,
    btc: 262,
    source: "https://bitfarms.com/app/uploads/2021/09/Bitfarms-Press-Release-Aug-BTC-Production-Update-FINAL-v9-Sep-8-2021.pdf"
  },
  {
    type: "monthly",
    year: 2021,
    month: 6,
    btc: 265,
    source: "https://bitfarms.com/app/uploads/2021/09/Bitfarms-Press-Release-Aug-BTC-Production-Update-FINAL-v9-Sep-8-2021.pdf"
  },
  {
    type: "monthly",
    year: 2021,
    month: 7,
    btc: 391,
    source: "https://bitfarms.com/app/uploads/2021/09/Bitfarms-Press-Release-Aug-BTC-Production-Update-FINAL-v9-Sep-8-2021.pdf"
  },
  {
    type: "monthly",
    year: 2021,
    month: 8,
    btc: 354,
    source: "https://bitfarms.com/app/uploads/2021/09/Bitfarms-Press-Release-Aug-BTC-Production-Update-FINAL-v9-Sep-8-2021.pdf"
  },
  {
    type: "monthly",
    year: 2021,
    month: 9,
    btc: 305,
    source: "https://bitfarms.com/app/uploads/2021/10/Bitfarms-Press-Release-Sep-BTC-Production-Update-FINAL-CLEAN-v5.c-Oct-1-2021.pdf"
  },
  {
    type: "monthly",
    year: 2021,
    month: 10,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 11,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 12,
    btc: 0,
    source: ""
  },
  /* Quarterly */
  {
    type: "quarterly",
    year: 2020,
    quarter: 1,
    btc: 1087,
    source: "https://bitfarms.com/app/uploads/2020/06/BITFARMS-Q1-2020-News-Release-Final.pdf"
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 2,
    btc: 815,
    source: "https://www.businesswire.com/news/home/20200828005036/en/"
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 3,
    btc: 535,
    source: "https://www.businesswire.com/news/home/20201126005462/en/Bitfarms-Reports-Q3-2020-Financial-Results"
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 4,
    btc: 577,
    source: "https://bitfarms.com/app/uploads/2021/03/BITFARMS-Q4-2020-NEWS-RELEASE-FINAL.pdf"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 1,
    btc: 598,
    source: "https://bitfarms.com/app/uploads/2021/05/BITFARMS-Q1-2021-PR-Final-Clean.pdf"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 2,
    btc: 759,
    source: "https://bitfarms.com/app/uploads/2021/08/BITFARMS-Q2-2021-PR-FINAL.pdf"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 3,
    btc: 1050,
    source: "https://bitfarms.com/app/uploads/2021/10/Bitfarms-Press-Release-Sep-BTC-Production-Update-FINAL-CLEAN-v5.c-Oct-1-2021.pdf"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 4,
    btc: 0,
    source: ""
  },
]
